import React, { useEffect, useRef, useState } from 'react';

const CountUpOnView = ({ end, label }) => {
  const ref = useRef();
  const [hasAnimated, setHasAnimated] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          observer.unobserve(ref.current); // Stop observing after animation triggers once
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [hasAnimated]);

  useEffect(() => {
    if (!hasAnimated) return;

    let start = 0;
    const duration = 1000; // 1 second
    const steps = 30;
    const increment = end / steps;
    const interval = duration / steps;

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(counter);
      } else {
        setCount(Math.ceil(start));
      }
    }, interval);
  }, [hasAnimated, end]);

  return (
    <div className="stats-box" ref={ref}>
      <h2>{count}+</h2>
      <p>{label}</p>
    </div>
  );
};

export default CountUpOnView;
